module.exports = __webpack_public_path__ + "static/media/rightmf.0a408358.png";